import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useErrorMessagesDispatch} from '../error-messages-context';
import useImpulseService from './use-impulse-service';

const RAZZLE_TECHNICAL_MERCHANT = process.env.RAZZLE_TECHNICAL_MERCHANT;

const useP2pError = ({serviceId}) => {
    const [p2pError, setP2pError] = React.useState(false);
    const errorDispatch = useErrorMessagesDispatch();
    const {serviceById} = useImpulseService({serviceId});
    React.useEffect(() => {
        if (serviceById && serviceById.mrchntd === RAZZLE_TECHNICAL_MERCHANT && serviceById.pools && serviceById.pools.length) {
            setP2pError(true);
            errorDispatch({
                type: 'add',
                payload: {
                    errorCode: 'p2pblock',
                    title: <FormattedMessage defaultMessage='Technical error'/>,
                    description: <FormattedMessage defaultMessage='Service temporarily unavailable'/>
                }
            });
        }
    }, [serviceById]);

    return (
        p2pError
    )

};

export default useP2pError;
